import { createActionCreator, createDeltaActionType, createSignalAction } from '../../../setup-react';

// ===== Signals ============================================================ //

// Stats
export const FETCH_SEASON_LEADERS = createSignalAction( 'statspro', 'FETCH_SEASON_LEADERS' );

// ===== Deltas ============================================================= //

// Stats
export const SET_SEASON_LEADERS = createDeltaActionType( 'statspro', 'SET_SEASON_LEADERS' );
export const setSeasonLeaders = createActionCreator( SET_SEASON_LEADERS );